@import 'styles/mixins';
@import 'styles/variables';

.initials {
  @include inter-regular;
  font-size: inherit;
  color: $white;
}
